import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0714b17f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index" }

import { getCurrentInstance, reactive, ref, onMounted, computed } from 'vue'
    import { watch } from 'vue'
    import { useStore } from "vuex"
    import { useRoute } from 'vue-router'
    import vTabBar from '@/components/common/TabBar.vue'
    import vHeader from '@/components/common/Header.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { proxy }: any = getCurrentInstance()
    const store = useStore()
    const route = useRoute()
    const title = ref<string>('')
    const isShow = ref<boolean>(false)
    const pathLists = reactive<string[]>([ '/index', '/workbench', '/bulletinboard', '/my' ])
    const env = computed(() => store.state.env)

    onMounted(() => {
        isShow.value = proxy.$dd.env.platform === 'notInDingTalk';
    })

    watch(() => route.meta.title, (newsPath, oldPath): void => {
        title.value = newsPath as string
    }, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(env) == 'H5')
      ? (_openBlock(), _createBlock(vHeader, {
          key: 0,
          pathList: _unref(pathLists)
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(title.value), 1)
          ]),
          _: 1
        }, 8, ["pathList"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "index_content",
      style: _normalizeStyle(_unref(store).state.type ? 'min-height: calc(100% - 64px)' : 'min-height: calc(100% - 108px)')
    }, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_unref(route).meta.keepAlive)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  key: _unref(route).meta.name
                }))
              : _createCommentVNode("", true)
          ], 1024)),
          (!_unref(route).meta.keepAlive)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: _unref(route).meta.name
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 4),
    _createVNode(vTabBar)
  ]))
}
}

})